import React from "react";
import { FaBackspace } from "react-icons/fa";
import "../../assets/css/NumericKeypad.css";

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

const NumericKeypad = ({ onPress, onDelete, onClear }) => {
  return (
    <div className="keypad">
      {keys.map((k) => (
        <button
          key={k}
          type="button"
          className="keypad-key"
          onClick={() => onPress(k)}
        >
          {k}
        </button>
      ))}

      <button type="button" className="keypad-key action" onClick={onDelete} aria-label="Supprimer">
        <FaBackspace />
      </button>

      <button type="button" className="keypad-key action clear" onClick={onClear}>
        C
      </button>
    </div>
  );
};

export default NumericKeypad;
